import { loadingState } from "global/LoaderState";
import { useRecoilState } from "recoil";
import "styles/css/loader.css";

const Loader = () => {
  const [isLoading] = useRecoilState(loadingState);
  if (!isLoading) return null;

  return (
    <div className="loader-overlay">
      <span className="loader"></span>
    </div>
  );
};

export default Loader;
